import { NotificationState } from "./notification.types";

const state = (): NotificationState => ({
  data: {},
  filters: {},
  meta: {
    page: {
      cursor: {}
    }
  }
})

export default state
